// @flow

import * as React from 'react';
import { Collapse as ReactCollapse } from 'react-collapse';
import { UpArrow, DownArrow } from '../icons';

type Props = {
  children: React.Node,
  /**
   * Required for proper accessibility support
   */
  id: string,
  /**
   * If the children of the component should be rendered
   */
  isOpened: boolean,
};

class Collapse extends React.Component<Props> {
  render() {
    return <ReactCollapse {...this.props} />;
  }
}

type ExpandProps = {
  expanded: boolean,
  'aria-controls': string,
  className?: string,
};

const ExpandArrow = ({
  expanded,
  'aria-controls': ariaControls,
  className,
}: ExpandProps) => {
  let Arrow = expanded ? UpArrow : DownArrow;
  return (
    <Arrow
      className={className}
      aria-controls={ariaControls}
      aria-expanded={expanded}
    />
  );
};

export { Collapse, ExpandArrow };
